export { default } from "./BrandHeroWrapper";
